import styled from "@emotion/styled";
import { grid, railsPage } from "constants/dimensions";

export const GridTitle = styled.div({
  position: "absolute",
  left: grid.firstColumn.x,
  top: railsPage.yLines.default - 68,
});
